import {
	createBrandThemeDefinition,
	createThemePreset,
	createThemeTokens,
	extendThemeTokens,
} from '../../../app/config/theme/helpers'

const defaultLight = createThemeTokens({
	background: 'oklch(0.9821 0 0)',
	foreground: 'oklch(0.2435 0 0)',
	card: 'oklch(0.9911 0 0)',
	'card-foreground': 'oklch(0.2435 0 0)',
	popover: 'oklch(0.9911 0 0)',
	'popover-foreground': 'oklch(0.2435 0 0)',
	primary: 'oklch(0.6786 0.0921 190.6338)',
	'primary-foreground': 'oklch(1.0000 0 0)',
	secondary: 'oklch(0.9254 0.0425 190.9811)',
	'secondary-foreground': 'oklch(0.6786 0.0921 190.6338)',
	muted: 'oklch(0.9521 0 0)',
	'muted-foreground': 'oklch(0.5032 0 0)',
	accent: 'oklch(0.9310 0 0)',
	'accent-foreground': 'oklch(0.2435 0 0)',
	destructive: 'oklch(0.6271 0.1936 33.3390)',
	'destructive-foreground': 'oklch(1.0000 0 0)',
	border: 'oklch(0.8822 0 0)',
	input: 'oklch(0.8822 0 0)',
	ring: 'oklch(0.4341 0.0392 41.9938)',
	'chart-1': 'oklch(0.6786 0.0921 190.6338)',
	'chart-2': 'oklch(0.9254 0.0425 190.9811)',
	'chart-3': 'oklch(0.9310 0 0)',
	'chart-4': 'oklch(0.9220 0.0181 48.5184)',
	'chart-5': 'oklch(0.8690 0.0519 230.3350)',
	sidebar: 'oklch(0.9881 0 0)',
	'sidebar-foreground': 'oklch(0.2645 0 0)',
	'sidebar-primary': 'oklch(0.3250 0 0)',
	'sidebar-primary-foreground': 'oklch(0.9881 0 0)',
	'sidebar-accent': 'oklch(0.9761 0 0)',
	'sidebar-accent-foreground': 'oklch(0.3250 0 0)',
	'sidebar-border': 'oklch(0.9401 0 0)',
	'sidebar-ring': 'oklch(0.7731 0 0)',
	'font-sans':
		"ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
	'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
	'font-mono':
		'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
	radius: '0.5rem',
	'shadow-x': '0',
	'shadow-y': '1px',
	'shadow-blur': '3px',
	'shadow-spread': '0px',
	'shadow-opacity': '0.1',
	'shadow-color': 'oklch(0 0 0)',
	'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
	'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
	'shadow-sm':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
	shadow:
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
	'shadow-md':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
	'shadow-lg':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
	'shadow-xl':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
	'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
	'tracking-normal': '0em',
	spacing: '0.25rem',
	'study-progress-not-started': 'var(--muted-foreground)',
	'study-progress-in-progress': 'var(--secondary-foreground)',
	'study-progress-completed': 'var(--chart-1)',
	'study-progress-deadline': 'var(--chart-5)',
	surface: 'var(--card)',
	'surface-elevated': 'oklch(0.98 0 0)',
	media: 'oklch(0.16 0 0)',
	overlay: '0 0% 0% / 0.65',
	'status-success-surface': 'oklch(0.97 0.04 145)',
	'status-success-text': 'oklch(0.42 0.12 145)',
	'status-success-border': 'oklch(0.82 0.05 145)',
	'status-warning-surface': 'oklch(0.97 0.05 85)',
	'status-warning-text': 'oklch(0.48 0.1 85)',
	'status-warning-border': 'oklch(0.84 0.06 85)',
	'status-danger-surface': 'oklch(0.97 0.05 25)',
	'status-danger-text': 'oklch(0.45 0.14 25)',
	'status-danger-border': 'oklch(0.83 0.06 25)',
	'status-info-surface': 'oklch(0.97 0.03 250)',
	'status-info-text': 'oklch(0.45 0.1 250)',
	'status-info-border': 'oklch(0.83 0.04 250)',
	success: 'var(--status-success-text)',
	warning: 'var(--status-warning-text)',
	info: 'var(--status-info-text)',
	danger: 'var(--status-danger-text)',
	'carousel-slide-0': 'oklch(0.30 0.06 191)',
	'carousel-slide-0-foreground': 'oklch(1 0 0)',
	'carousel-slide-1': 'oklch(0.25 0.03 230)',
	'carousel-slide-1-foreground': 'oklch(1 0 0)',
	'carousel-slide-2': 'oklch(0.35 0.07 191)',
	'carousel-slide-2-foreground': 'oklch(1 0 0)',
	'carousel-slide-3': 'oklch(0.28 0.04 67)',
	'carousel-slide-3-foreground': 'oklch(0.18 0 0)',
	'carousel-slide-4': 'oklch(0.22 0.05 191)',
	'carousel-slide-4-foreground': 'oklch(1 0 0)',
	'reading-foreground': 'var(--foreground)',
	'border-strong': 'var(--input)',
	gold: 'var(--secondary)',
	'gold-text': 'var(--secondary)',
	'gold-wash': 'var(--muted)',
})

const defaultDark = createThemeTokens({
	background: 'oklch(0.1776 0 0)',
	foreground: 'oklch(0.9491 0 0)',
	card: 'oklch(0.2134 0 0)',
	'card-foreground': 'oklch(0.9491 0 0)',
	popover: 'oklch(0.2134 0 0)',
	'popover-foreground': 'oklch(0.9491 0 0)',
	primary: 'oklch(0.9247 0.0524 66.1732)',
	'primary-foreground': 'oklch(0.2029 0.0240 200.1962)',
	secondary: 'oklch(0.3163 0.0190 63.6992)',
	'secondary-foreground': 'oklch(0.9247 0.0524 66.1732)',
	muted: 'oklch(0.2520 0 0)',
	'muted-foreground': 'oklch(0.7699 0 0)',
	accent: 'oklch(0.2850 0 0)',
	'accent-foreground': 'oklch(0.9491 0 0)',
	destructive: 'oklch(0.6271 0.1936 33.3390)',
	'destructive-foreground': 'oklch(1.0000 0 0)',
	border: 'oklch(0.2351 0.0115 91.7467)',
	input: 'oklch(0.4017 0 0)',
	ring: 'oklch(0.9247 0.0524 66.1732)',
	'chart-1': 'oklch(0.9247 0.0524 66.1732)',
	'chart-2': 'oklch(0.3163 0.0190 63.6992)',
	'chart-3': 'oklch(0.2850 0 0)',
	'chart-4': 'oklch(0.3481 0.0219 67.0001)',
	'chart-5': 'oklch(0.9245 0.0533 67.0855)',
	sidebar: 'oklch(0.2103 0.0059 285.8852)',
	'sidebar-foreground': 'oklch(0.9674 0.0013 286.3752)',
	'sidebar-primary': 'oklch(0.4882 0.2172 264.3763)',
	'sidebar-primary-foreground': 'oklch(1.0000 0 0)',
	'sidebar-accent': 'oklch(0.2739 0.0055 286.0326)',
	'sidebar-accent-foreground': 'oklch(0.9674 0.0013 286.3752)',
	'sidebar-border': 'oklch(0.2739 0.0055 286.0326)',
	'sidebar-ring': 'oklch(0.8711 0.0055 286.2860)',
	'font-sans':
		"ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
	'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
	'font-mono':
		'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
	radius: '0.5rem',
	'shadow-x': '0',
	'shadow-y': '1px',
	'shadow-blur': '3px',
	'shadow-spread': '0px',
	'shadow-opacity': '0.1',
	'shadow-color': 'oklch(0 0 0)',
	'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
	'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
	'shadow-sm':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
	shadow:
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
	'shadow-md':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
	'shadow-lg':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
	'shadow-xl':
		'0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
	'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
	'tracking-normal': '0em',
	spacing: '0.25rem',
	'study-progress-not-started': 'var(--muted-foreground)',
	'study-progress-in-progress': 'var(--secondary-foreground)',
	'study-progress-completed': 'var(--chart-1)',
	'study-progress-deadline': 'var(--chart-5)',
	surface: 'oklch(0.18 0 0)',
	'surface-elevated': 'oklch(0.22 0 0)',
	media: 'oklch(0.1 0 0)',
	overlay: '0 0% 0% / 0.75',
	'status-success-surface': 'oklch(0.26 0.06 145)',
	'status-success-text': 'oklch(0.88 0.06 145)',
	'status-success-border': 'oklch(0.4 0.07 145)',
	'status-warning-surface': 'oklch(0.26 0.05 85)',
	'status-warning-text': 'oklch(0.9 0.07 85)',
	'status-warning-border': 'oklch(0.4 0.06 85)',
	'status-danger-surface': 'oklch(0.26 0.06 25)',
	'status-danger-text': 'oklch(0.9 0.08 25)',
	'status-danger-border': 'oklch(0.4 0.07 25)',
	'status-info-surface': 'oklch(0.26 0.04 250)',
	'status-info-text': 'oklch(0.88 0.06 250)',
	'status-info-border': 'oklch(0.4 0.05 250)',
	success: 'var(--status-success-text)',
	warning: 'var(--status-warning-text)',
	info: 'var(--status-info-text)',
	danger: 'var(--status-danger-text)',
	'carousel-slide-0': 'oklch(0.22 0.05 191)',
	'carousel-slide-0-foreground': 'oklch(0.95 0 0)',
	'carousel-slide-1': 'oklch(0.18 0.03 230)',
	'carousel-slide-1-foreground': 'oklch(0.95 0 0)',
	'carousel-slide-2': 'oklch(0.26 0.06 191)',
	'carousel-slide-2-foreground': 'oklch(0.95 0 0)',
	'carousel-slide-3': 'oklch(0.20 0.04 67)',
	'carousel-slide-3-foreground': 'oklch(0.95 0 0)',
	'carousel-slide-4': 'oklch(0.16 0.04 191)',
	'carousel-slide-4-foreground': 'oklch(0.95 0 0)',
	'reading-foreground': 'var(--foreground)',
	'border-strong': 'var(--input)',
	gold: 'var(--secondary)',
	'gold-text': 'var(--secondary)',
	'gold-wash': 'var(--muted)',
})

const pulseLight = extendThemeTokens(defaultLight, {
	primary: 'oklch(0.61 0.19 264)',
	secondary: 'oklch(0.92 0.05 220)',
	'secondary-foreground': 'oklch(0.31 0.05 240)',
	accent: 'oklch(0.93 0.04 250)',
	ring: 'oklch(0.61 0.19 264)',
	'chart-1': 'oklch(0.61 0.19 264)',
	'chart-2': 'oklch(0.66 0.14 192)',
	sidebar: 'oklch(0.975 0.01 254)',
	'sidebar-primary': 'oklch(0.61 0.19 264)',
	'sidebar-accent': 'oklch(0.94 0.02 245)',
	'carousel-slide-0': 'oklch(0.32 0.09 250)',
	'carousel-slide-2': 'oklch(0.36 0.1 210)',
	'carousel-slide-4': 'oklch(0.27 0.08 260)',
})

const pulseDark = extendThemeTokens(defaultDark, {
	primary: 'oklch(0.69 0.16 264)',
	'primary-foreground': 'oklch(0.15 0.02 250)',
	secondary: 'oklch(0.26 0.03 236)',
	'secondary-foreground': 'oklch(0.9 0.03 240)',
	accent: 'oklch(0.23 0.03 245)',
	ring: 'oklch(0.69 0.16 264)',
	'chart-1': 'oklch(0.69 0.16 264)',
	'chart-2': 'oklch(0.66 0.12 195)',
	sidebar: 'oklch(0.17 0.015 250)',
	'sidebar-primary': 'oklch(0.69 0.16 264)',
	'sidebar-primary-foreground': 'oklch(0.15 0.02 250)',
	'sidebar-accent': 'oklch(0.22 0.02 245)',
	'sidebar-border': 'oklch(0.26 0.01 245)',
	'carousel-slide-0': 'oklch(0.24 0.08 250)',
	'carousel-slide-2': 'oklch(0.28 0.08 205)',
	'carousel-slide-4': 'oklch(0.2 0.07 262)',
})

const spabelTheme = createBrandThemeDefinition({
	brandKey: 'spabel',
	defaultPreset: 'default',
	presets: {
		default: createThemePreset({
			key: 'default',
			label: 'Brand default',
			description: 'Balanced blue product palette with calm neutral surfaces.',
			tokens: {
				light: defaultLight,
				dark: defaultDark,
			},
		}),
		pulse: createThemePreset({
			key: 'pulse',
			label: 'Pulse',
			description:
				'Sharper indigo energy with brighter product accents and a more electric sidebar.',
			tokens: {
				light: pulseLight,
				dark: pulseDark,
			},
		}),
	},
})

export default spabelTheme
